import DisplayProducts from "@crescentParts/Components/DisplayProduct";
import MultiSelectDropdown, { Option } from "@crescentParts/Components/MultiSelectDropDown";
import getAHRISystemToolHandlerData from "@crescentParts/Handlers/AHRIHandler/AHRIDataHandler";
import getAHRISystemToolHandlerAttribute from "@crescentParts/Handlers/AHRIHandler/AHRIToolAttribute";
import CustomApplicationState from "@crescentParts/Store/CustomApplicationState";
import AHRISystemToolAhriAttributesHandler from "@crescentParts/Store/Data/AHRISystemData/Handler/AHRIAttribute";
import AHRISystemToolAhriDataHandler from "@crescentParts/Store/Data/AHRISystemData/Handler/FetchProduct";
import { getAHRISystemCurrentPageState } from "@crescentParts/Store/Data/AHRISystemToolPagination/AHRISystemToolPaginationSelector";
import AHRISystemToolPageSizeHandler from "@crescentParts/Store/Data/AHRISystemToolPagination/Handler/AHRISystemToolPageSize";
import AHRISystemPaginationHandler from "@crescentParts/Store/Data/AHRISystemToolPagination/Handler/AHRIToolPagination";
import { AHRISystemToolAttributeModel } from "@crescentParts/Widgets/CustomApiModels";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext } from "@insite/client-framework/Components/IsInShell";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import debounce from "lodash/debounce";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps } from "styled-components";

const mapDispatchToProps = {
    getAHRISystemToolHandlerAttribute,
    getAHRISystemToolHandlerData,
    AHRISystemToolAhriDataHandler,
    AHRISystemPaginationHandler,
    AHRISystemToolAhriAttributesHandler,
    loadRealTimeInventory,
    AHRISystemToolPageSizeHandler
};

const mapStateToProps = (state: ApplicationState & CustomApplicationState) => {
    const getCurrentPage = getAHRISystemCurrentPageState(state);
    const defaultPageNumber = state?.cpeState?.AHRISystemToolPagination?.ahriSystemToolPageNumber;
    const defaultPageSize = state?.cpeState?.AHRISystemToolPagination?.ahriSystemToolPageSize;
    return {
        getCurrentPage,
        ahriSorting: state.cpeState.AHRISystemData.ahriSorting,
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        currentLocation: getLocation(state),
        isAuthenticated: state.context.session?.isAuthenticated || !state.context.session?.isGuest,
        defaultPageNumber,
        defaultPageSize,
        ahriPagination: state.cpeState.AHRISystemData.ahriPagination,
    };
};

export interface CategoryDropdownStyles {
    dropDownGridItem?: GridItemProps;
}
interface KeyValueModel {
    [key: string]: any
}

interface Pair {
    displayName: string;
    status: string;
}

interface KeyValuePair {
    attribute: string;
    values: Pair[];
}


interface OwnProps extends WidgetProps {

}
type Props = OwnProps & ThemeProps<BaseTheme> &
    HasShellContext &
    ResolveThunks<typeof mapDispatchToProps> &
    ReturnType<typeof mapStateToProps> & HasHistory;

export const categoryStyles: CategoryDropdownStyles = {
    dropDownGridItem: {
        width: [12, 12, 12, 6, 6],
    },
};

export interface AttributesDropdownStyles {
    attributesContainer?: InjectableCss;
    attributesDropdowns?: InjectableCss;
    attributeValue?: InjectableCss;
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
    searchNotFound?: TypographyPresentationProps;
    searchNotFoundItem?: GridItemProps;
    wrapper?: SearchFieldWrapperStyles;
    seachByAhri?: InjectableCss;
    ahriButtons?: InjectableCss;
    clearAllButton?: ButtonPresentationProps;
    pagination?: PaginationPresentationProps;
}

export const attributeStyles: AttributesDropdownStyles = {
    attributesContainer: {
        css: css`
            margin-top: 28px;
        `,
    },
    attributesDropdowns: {
        css: css`
            border: 1px solid #ccc;
            padding: 10px;
            margin-bottom: 10px;
        `,
    },
    ahriButtons: {
        css: css`
            max-width: 33.33%;
            flex-basis: 33.33%;
            align-items: center;
            > div:first-child {
                margin-top : 30px;
            }
        `
    },
    clearAllButton: {
        css: css`
            margin-top : 30px;
        `
    },
    seachByAhri: {
        css: css`
            max-width: 33.33%;
            flex-basis: 33.33%;
            > div:first-child {
                padding: 10px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100%;
                            flex-basis: 100%;
                        `,
                        css`
                            max-width: 100%;
                            flex-basis: 100%;
                        `,
                        css`
                            max-width: 50%;
                            flex-basis: 50%;
                        `,
                        null,
                        null
                    ]
                )
            }
        `,
    },
    gridContainer: {
        gap: 28,
        css: css`
            margin: 10px 0px 30px 0px;
        `,
    },
    gridItem: {
        width: [12, 12, 6, 4, 4],
    },
    searchNotFoundItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
        isplay: flex;
        justify-content: center;
        `
    },
    searchNotFound: {
        size: 20,
        css: css`
            text-align: center;
        `,
    },
};
const aStyles = attributeStyles;

const AHRISystemTool: React.FC<Props> = ({
    getCurrentPage,
    ahriSorting,
    getAHRISystemToolHandlerData,
    getAHRISystemToolHandlerAttribute,
    AHRISystemToolAhriDataHandler,
    AHRISystemPaginationHandler,
    AHRISystemToolAhriAttributesHandler,
    loadRealTimeInventory,
    history,
    signInUrl,
    isAuthenticated,
    currentLocation,
    defaultPageNumber,
    defaultPageSize,
    ahriPagination,
    AHRISystemToolPageSizeHandler,
    id
}) => {
    const [attributeDropDownOption, setAttributeDropDownOption] = useState<any[]>([]);
    const [selectedattributes, setSelectedattributes] = useState<any>({});
    const [finalAttributeCollection, setFinalAttributeCollection] = useState<KeyValueModel>({});
    const [loader, setLoader] = useState(false);
    const [inventoryLoader, setInventoryLoader] = useState(false);
    const totalItemCount = ahriPagination?.totalItemCount || null;
    const [currentPage, setCurentPage] = useState<number>(defaultPageNumber);
    const [currentPageSize, setCurentPageSize] = useState<number>(defaultPageSize);

    const capitalizeFirstLetter = (word: string) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
    };
    const [ahriNumber, setAhriNumber] = useState<string>("");

    const arrangeAttribute = (data: AHRISystemToolAttributeModel) => {
        const allAtribute: KeyValuePair[] = [];

        Object.keys(data).forEach((o, i) => {
            const obj: KeyValuePair = {
                attribute: "",
                values: []
            }

            data[o]?.forEach((attr: any, i) => {
                const key = Object.keys(attr)[0];
                obj.attribute = key;
                obj.values.push({
                    "displayName": attr[key],
                    "status": `${i}`
                });
            });
            allAtribute.push(obj);
        });

        setAttributeDropDownOption(allAtribute);
    }

    useEffect(() => {
        if(!isAuthenticated && signInUrl) {
            const returnUrl = currentLocation.pathname + currentLocation.search;
            if (returnUrl === "/") {
                history.push(`${signInUrl}`);
            } else {
                history.push(`${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}`);
            }
        } else if(isAuthenticated) {
            getAHRISystemToolHandlerAttribute({
                onSuccess: (result: AHRISystemToolAttributeModel) => {
                    if (result) {
                        arrangeAttribute(result)
                    }
                }
            });
        }
    }, [signInUrl, currentLocation]);

    const handleOptionChange = (option: Option, attribute: KeyValuePair) => {
        const isSelected = selectedattributes && selectedattributes[attribute.attribute]
            ? selectedattributes[attribute.attribute].indexOf(option.value) > -1
            : false;

        let status: string[] = selectedattributes[attribute.attribute]
                ? [...selectedattributes[attribute.attribute]]
                : [];

        if (isSelected) {
            status = selectedattributes[attribute.attribute] && selectedattributes[attribute.attribute].filter((val: string) => {
                return option.value !== val
            });
        } else {
            status.push(option.value);
        }
        
        if (status.length > 0) {
            const obj = { ...selectedattributes }
            obj[attribute.attribute] = status;
            setSelectedattributes(obj);
        } else {
            const obj = {
                ...selectedattributes,
                [attribute.attribute]: undefined
            }
            setSelectedattributes(obj);
        }
        
    };

    useEffect(() => {
        // AHRISystemToolAhriDataHandler({
        //     ahriData: null,
        //     ahriPagination: {},
        // });
        let _finalObject: KeyValueModel = { ...finalAttributeCollection };
        Object.keys(selectedattributes).forEach((attribute) => {
            if(!_finalObject[attribute]) {
                _finalObject = {
                    ..._finalObject,
                    [attribute]: [{ label: attribute, value: selectedattributes[attribute] }],
                }
            }

            attributeDropDownOption.forEach((ddAttr, i) => {
                if (attribute === ddAttr.attribute) {
                    const options = ddAttr.values || [];
                    const uniqueOptions = new Map<string, string[]>();
                    for (const option of options) {
                        const statuses = uniqueOptions.get(option.displayName) || [];
                        statuses.push(option.status);
                        uniqueOptions.set(option.displayName, statuses);
                    }
                    const dropDownOptions: any[] = Array.from(uniqueOptions, ([name, values]) => ({ name, values })).map(
                        option => ({
                            value: option.values.join(","),
                            label: option.name,
                            attribute: ddAttr.attribute
                        }),
                    );

                    const obj: { label: string; value: string; }[] = [];
                    if(selectedattributes[attribute]) {
                        dropDownOptions.forEach((opt) => {
                            selectedattributes[attribute].forEach((value: any) => {
                                if(value === opt.value) {
                                    obj.push({
                                        label: opt.label,
                                        value: opt.value
                                    })
                                }
                            });
                        });
                    }

                    _finalObject = {
                        ..._finalObject,
                        [attribute]: obj
                    };
                }
            });
            setFinalAttributeCollection(_finalObject);
            AHRISystemToolAhriAttributesHandler({ attributes: _finalObject })
            
        });
    }, [selectedattributes]);

    const filterProductIds = (data: any) => {
        const ids: any = {};
        data.filter((product: any) => product.productId).forEach((product: any) => {
            const ahriProduct = product.productId.split(",");
            ahriProduct.forEach((ahri: string) => {
                ids[ahri.split(":")[1]] = ahri.split(":")[0];
            });
        });
        return ids;
    }
    useEffect(() => {
        getAHRISystemToolAPI(1);
    }, []);
    
    const changePage = (newPageIndex: number) => {
        AHRISystemPaginationHandler({
            ahriSystemToolPageNumber: newPageIndex,
        });
        setCurentPage(newPageIndex);
        getAHRISystemToolAPI(newPageIndex);
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = Number(event.currentTarget.value);
        setCurentPageSize(newPageSize);
        AHRISystemToolPageSizeHandler({
            ahriSystemToolPageSize: newPageSize
        })

        AHRISystemPaginationHandler({
            ahriSystemToolPageNumber: 1,
        });
        setCurentPage(1);
        getAHRISystemToolAPI(1);
    };

    useEffect(() => {
        setCurentPage(defaultPageNumber);
        setCurentPageSize(defaultPageSize);
    }, [defaultPageNumber, ahriPagination, defaultPageSize]);

    const getAHRISystemToolAPI = (pageNo?: number, isClear?: boolean) => {
        AHRISystemToolAhriDataHandler({
            ahriData: null,
            ahriPagination: {},
        });
        const parameter: KeyValueModel = {};
        setLoader(true);
        if(!isClear){
            Object.keys(finalAttributeCollection).forEach(( attribute ) => {
                const key = attribute.replace(/ /g, "_")
                const data = finalAttributeCollection[attribute].map((attr: any) => attr.label).join(",");
                parameter[key] = data;
            });
        }
        setInventoryLoader(true);
        getAHRISystemToolHandlerData({
            Family: parameter["brand"],
            AC_HeatPump: parameter["aC_or_Heat_Pump"],
            Outdoor_Unit_Tonnage: parameter["outdoor_Unit_Tonnage"],
            Family_SEER2: parameter["seer2_Family"],
            Indoor_Type: parameter["indoor_Type"],
            Furnace_BTU: parameter["furnace_BTU"],
            Indoor_Position: parameter["indoor_Position"],
            C25_Tax_Credit_Qualified: parameter["25C_Tax_Credit_Qualified"] || "",
            page: pageNo || getCurrentPage.ahriSystemToolPageNumber,
            Sort: ahriSorting || "",
            search: ahriNumber || "",
            refrigerant: parameter["refrigerant"],
            onSuccess: result => {
                if (result) {
                    setLoader(false);
                    const ahriDataModified = JSON.parse(JSON.stringify(result.data));
                    ahriDataModified?.forEach((ahri: any) => {
                        const ahriProduct = ahri?.productId?.split(",") ?? [];
                        ahriProduct.forEach((ahriP: string) => {
                            const id = ahriP.split(":");
                            ahri[id[0]] = {
                                productId: id[1],
                                qtyOnHand: parseInt(id[2], 10)
                            }
                        });
                    });
                    AHRISystemToolAhriDataHandler({
                        ahriData: ahriDataModified,
                        ahriPagination: result.pagination
                    });
                    setInventoryLoader(false);
                }
            }          
        });
    }
    const debounceFun = React.useCallback(debounce((value: string) => {
        setSelectedattributes({ ...selectedattributes, search: value });
    }, 500), []);

    const handleInputChange = (data: React.ChangeEvent<HTMLInputElement>) => {
        AHRISystemPaginationHandler({
            ahriSystemToolPageNumber: 1,
        });
        setAhriNumber(data.target.value);
        debounceFun(data.target.value);
    };


    const clearAllFilters = () => {
        setAhriNumber("");
        setSelectedattributes({});
        setFinalAttributeCollection({});
        AHRISystemPaginationHandler({
            ahriSystemToolPageNumber: 1,
        });
        getAHRISystemToolAPI(1,true);
    }

    const submitAllFilters = () => {
        AHRISystemPaginationHandler({
            ahriSystemToolPageNumber: 1,
        });
        getAHRISystemToolAPI(1);
    }

    if (!isAuthenticated) {
        return null;
    }
    return (
        <StyledWrapper>
            <StyledWrapper data-test-selector="categoriesContainer">
                <StyledWrapper {...aStyles.attributesContainer} data-test-selector="attributesContainer">
                    <StyledWrapper {...aStyles.attributesDropdowns} data-test-selector="attributesDropdowns">
                    <LoadingOverlay
                            loading={inventoryLoader}
                            css={css`
                                width: 100%;
                            `}
                        >
                        <GridContainer {...aStyles.gridContainer}>
                            {attributeDropDownOption.map((attribute, i) => {
                                const options = attribute.values || [];
                                const uniqueOptions = new Map<string, string[]>();
                                for (const option of options) {
                                    const statuses = uniqueOptions.get(option.displayName) || [];
                                    statuses.push(option.status);
                                    uniqueOptions.set(option.displayName, statuses);
                                }

                                const dropDownOptions: any[] = Array.from(uniqueOptions, ([name, values]) => ({ name, values })).map(
                                    option => ({
                                        value: option.values.join(","),
                                        label: option.name
                                    }),
                                );
                                return (
                                    <GridItem key={i} {...aStyles.gridItem}>
                                        <SearchFieldWrapper extendedStyles={aStyles.wrapper} key={`SearchFieldWrapper-${i}`}>
                                            <MultiSelectDropdown
                                                key={`MultiSelectDropdown-${i}`}
                                                label={capitalizeFirstLetter(attribute.attribute).split("_").join(" ")}
                                                handleOptionClick={(option) => handleOptionChange(option, attribute)}
                                                options={dropDownOptions}
                                                selectedOptions={finalAttributeCollection[attribute.attribute] || []}
                                            />
                                        </SearchFieldWrapper>
                                    </GridItem>
                                )
                            })}
                            {attributeDropDownOption.length > 0 && <><GridItem {...aStyles.seachByAhri}>
                                <TextField
                                    value={ahriNumber}
                                    clickableText={translate("Search")}
                                    label={translate("AHRI No")}
                                    onChange={handleInputChange}
                                    data-test-selector="searchByAhriNumber"
                                    placeholder={translate("Search by AHRI")}
                                    autoComplete="off"
                                />
                            </GridItem>
                            <GridItem {...aStyles.ahriButtons}>
                                <Button
                                    {...aStyles.clearAllButton}
                                    onClick={clearAllFilters}
                                    data-test-selector="ahri_system_clear_filter"
                                >
                                    {translate("Clear All")}
                                </Button>
                            </GridItem>
                            <GridItem {...aStyles.ahriButtons}>
                                <Button
                                    {...aStyles.clearAllButton}
                                    onClick={submitAllFilters}
                                    data-test-selector="ahri_system_submit_filter"
                                >
                                    {translate("Submit")}
                                </Button>
                            </GridItem></>}
                        </GridContainer>
                        </LoadingOverlay>
                        <DisplayProducts loader={loader} inventoryLoader={inventoryLoader} setLoader={setLoader} id={id}/>
                        {ahriPagination && totalItemCount !== 0 ? 
                                <Pagination
                                        {...aStyles.pagination}
                                        resultsCount={totalItemCount as number}
                                        currentPage={currentPage}
                                        resultsPerPage={currentPageSize}
                                        resultsPerPageOptions={[]}
                                        onChangePage={changePage}
                                        onChangeResultsPerPage={changeResultsPerPage}
                                        pageSizeCookie="AHRIToolPage-PageSize"
                                    />
                                    : null
                            }
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const definition: WidgetDefinition = {
    group: "Basic",
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(AHRISystemTool)),
    definition,
};

export default widgetModule;